/**
 * DEFAULT_COLORS — the fallback chart colour palette used when no explicit
 * theme or per-series override is configured.
 *
 * Sourced from Tableau 10 with minor accessibility adjustments.
 * This is the single source of truth — other packages should import from here
 * (or re-export) rather than maintaining their own copy.
 */
export const DEFAULT_COLORS: string[] = [
  '#4E79A7', '#F28E2B', '#E15759', '#76B7B2',
  '#59A14F', '#EDC948', '#B07AA1', '#FF9DA7',
];
